import React, { useState, useEffect } from "react"
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Row,
    Col
} from "reactstrap"
import { useTranslation } from 'react-i18next'

const ModalComponent = (props) => {

    let { toggle, isOpen, title, subTitle, children, size, hasFooter, saveText, onSave, isSaving, removeBodyPaddings, hideCancelBtn = false } = props

    let { t } = useTranslation()

    return (
        <Modal
            isOpen={isOpen}
            size={size ?? "lg"}
            scrollable={true}
        // toggle={toggle}
        // centered={true}
        >
            {/* <ModalHeader>{title}</ModalHeader> */}

            {/* header */}
            <div className="modal-header border-bottom px-0 mx-0">
                <Row>
                    <Col md='1' />
                    <Col>
                        <h5 className="modal-title" id="myModalLabel">
                            {title}
                        </h5>
                        {subTitle && (
                            <h5 className="modal-title" id="myModalLabel">
                                {subTitle}
                            </h5>
                        )}
                    </Col>
                    <Col md='1' className='mr-3'>
                        <button
                            aria-hidden={true}
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={toggle}
                            disabled={isSaving}
                        >
                            <i className="nc-icon nc-simple-remove" />
                        </button>
                    </Col>
                </Row>

            </div>

            <ModalBody className={`${removeBodyPaddings ? 'p-0 m-0' : ''}`}>

                {children}

            </ModalBody>

            {hasFooter && (
                <ModalFooter className='px-3'>

                    {!hideCancelBtn && (
                        <Button color="danger" outline className="mr-3" disabled={isSaving} onClick={toggle}>
                            {t('cancel')}
                        </Button>
                    )}

                    <Button color="success" disabled={isSaving} onClick={onSave}>
                        {isSaving ? t('loading') : (saveText ?? t('save'))}
                    </Button>{" "}

                </ModalFooter>
            )}

            {props.customFooter && (
                <ModalFooter className='px-3'>
                    {props.customFooter}
                </ModalFooter>
            )}
            
        </Modal>
    )

}

export default ModalComponent